import React, { useEffect, useRef, useCallback } from 'react';
import { useTheme } from '@material-ui/core/styles';

function SignatureCanvas({ data }) {
  const canvasRef = useRef(null);
  // The signature is re-drawn from stored point data, so the ink colour is ours
  // to choose. Hardcoded '#000' made it invisible on a dark page.
  // `text.primary` is exactly black in the light theme.
  const theme = useTheme();
  const inkColor = theme.palette.text.primary;

  const parseData = useCallback((dataString) => {
    if (!dataString) return [];
    const points = dataString.split('_');
    const strokesArray = [];
    let currentStrokeArray = [];

    points.forEach((point) => {
      if (point === 'null,null') {
        if (currentStrokeArray.length > 0) {
          strokesArray.push(currentStrokeArray);
          currentStrokeArray = [];
        }
      } else {
        const [x, y] = point.split(',').map(Number);
        currentStrokeArray.push({ x, y });
      }
    });

    if (currentStrokeArray.length > 0) {
      strokesArray.push(currentStrokeArray);
    }

    return strokesArray;
  }, []);

  const drawSignature = useCallback((strokes) => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    ctx.strokeStyle = inkColor;
    ctx.lineWidth = 2;

    strokes.forEach((stroke) => {
      if (stroke.length > 0) {
        ctx.beginPath();
        ctx.moveTo(stroke[0].x, stroke[0].y);
        for (let i = 1; i < stroke.length; i += 1) {
          ctx.lineTo(stroke[i].x, stroke[i].y);
        }
        ctx.stroke();
      }
    });
  }, [inkColor]);

  useEffect(() => {
    const strokes = parseData(data);
    drawSignature(strokes);
  }, [data, parseData, drawSignature]);

  return <canvas ref={canvasRef} width={300} height={180}/>;
}

export default SignatureCanvas;
